import React, { useState } from "react";
import { Grommet, Box, ResponsiveContext } from 'grommet';
import { hpe } from 'grommet-theme-hpe';
import { Header, Notification, AgentSidebar, PageFooter, ContentDisplay } from './components';
import { Home } from './pages/home';
import { ArchiveHome } from './pages/archive';
import { LatestHome } from './pages/latest-event';
import { BlogHome } from './pages/blog';
import { InnovationHome } from './pages/innovation';
import { SitesHome } from './pages/sites';
import { ExperienceHome } from './pages/experience';
import { SustainabilityHome } from './pages/sustainability';
import { LearnHome } from './pages/learn';
import { UserJourneySummaryView } from './pages/userJourneys'
import { ValueStreamsHome } from './pages/valuestreams';
import { RoadmapsHome, RoadmapSummary, RoadmapDisplay } from './pages/roadmaps';
import { ProductLedHome } from './pages/productled';
import { LeadToCashSystems } from './pages/roadmaps/systems';
import { EAHome } from './pages/ea';
import { TCPHome } from './pages/tcp';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HeaderHeightProvider } from './utils/HeaderHeightContext';


function App() {

    // State to track if the agent dialog is expanded or collapsed
  const [isAgentExpanded, setIsAgentExpanded] = useState(false);

  // Toggle function to expand/collapse the agent
  const toggleAgent = () => {
    setIsAgentExpanded((prev) => !prev);
  };
  
  return (
    <HeaderHeightProvider> 
      <BrowserRouter>
        <Grommet className="App" theme={hpe} full>
          <ResponsiveContext.Consumer>
            {size => (
              <Box fill background="background-back" direction="column" style={{ height: '100vh' }}>

                {/* Header */}
                <Box width="100%" elevation="medium" flex={false}>
                  <Header toggleAgent={toggleAgent} />
                </Box>

                {/* Main Content */}
                <Box flex="grow" overflow="auto">
                  <Notification />
                  <Box margin={{ top: 'xxsmall' }} direction="row" flex="grow" >
                    <Box flex={true} overflow="auto">
                      <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/sites" element={<SitesHome />} />
                        <Route path="/experience" element={<ExperienceHome />} />
                        <Route path="/archive/:tabId?" element={<ArchiveHome />} />
                        <Route path="/latest/:tabId?" element={<LatestHome />} />
                        <Route path="/sustainability" element={<SustainabilityHome />} />                        
                        <Route path="/learn" element={<LearnHome />} />
                        <Route path="/innovation" element={<InnovationHome />} />
                        <Route path="/ea" element={<EAHome />} />
                        <Route path="/blog" element={<BlogHome />} />
                        <Route path="/valuestreams" element={<ValueStreamsHome />} />
                        <Route path="/roadmaps" element={<RoadmapsHome />} />
                        <Route path="/roadmap-display" element={<RoadmapDisplay />} />
                        <Route path="/roadmap-summary" element={<RoadmapSummary />} />
                        <Route path="/productled" element={<ProductLedHome />} />
                        <Route path="/systems/lead-to-cash" element={<LeadToCashSystems />} />
                        <Route path="/user-journeys" element={<UserJourneySummaryView />} />
                        <Route path="/tcp" element={<TCPHome />} />
                        <Route path="/content-display" element={<ContentDisplay />} />
                        <Route path="*" element={<Home />} />
                      </Routes>  
                    </Box>
                    <AgentSidebar isAgentExpanded={isAgentExpanded} />
                  </Box>
                </Box>

                {/* Footer */}
                <Box width="100%" flex={false}>
                  <PageFooter />
                </Box>

              </Box>
            )}
          </ResponsiveContext.Consumer>
        </Grommet>
      </BrowserRouter>
    </HeaderHeightProvider>
  );
}

export default App;
